/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Col, Row } from 'react-bootstrap';
import DonutChart from '../../donutchart/DonutChart';
import data from './membercoverages.json';

import EnableIntegration from '../../../shared/EnableIntegration';
import MemberSummary from '../../../api/MemberSummary';
import MemberCoverageSummary from '../../../api/MemberCoverageSummary';
import MasterPermissions from '../../../api/MasterPermissions';
import './Coverage.scss';
import { withTranslation } from 'react-i18next';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1250 },
    items: 3,
  },
  desktop1: {
    breakpoint: { max: 1250, min: 1024 },
    items: 2.5,
  },
  desktop2: {
    breakpoint: { max: 1024, min: 900 },
    items: 2,
  },
  desktop3: {
    breakpoint: { max: 900, min: 800 },
    items: 1.8,
  },
  desktop4: {
    breakpoint: { max: 800, min: 576 },
    items: 1.5,
  },
  mobile: {
    breakpoint: { max: 576, min: 0 },
    items: 1,
  },
};

class CarouselSlider extends React.Component {
  state = {
    additionalTransfrom: 0,
    data: [],
    disableIntegration: EnableIntegration.isAPIIntegrationEnabled(),
  };

  constructor(props) {
    super(props);
    EnableIntegration.ToggleAPIIntegration(EnableIntegration.enableIntegration);
    console.log('Integrated Flag', this.state.disableIntegration);
  }

  render() {
    let iIndex = 0;
    const products = [];
    //Accumulators
    let InNetworkRemaining = 0;
    let OOPRemaining = 0;
    let InNetworkPercent = 0;
    let OOPPercent = 0;
    const InNetworkDed = [];
    const DedFamilyAmt = [];
    const InNetworkOOP = [];
    const FamilyOOP = [];
    let selectedItem = 0;
    let coverageDetailsRoute = '/member/coverage';
    const selectedIndex = MemberCoverageSummary.getSelectedItem();

    const { t } = this.props;

    coverageDetailsRoute =
      coverageDetailsRoute +
      '?selectedIndex=' +
      selectedIndex +
      '&coverageType=';
    console.log('SELECTED ITEM: ', selectedIndex);
    //End of Accumulator

    const membercoverageStaticResp = data.Response;
    const membercoverageResp = MemberCoverageSummary.getMemberCoverage(
      MemberCoverageSummary.getSelectedItem(),
    );
    const memberAccumDetailsResp = MemberCoverageSummary.getAccoumulatorDetails(
      MemberCoverageSummary.getSelectedItem(),
    );

    if (EnableIntegration.isAPIIntegrationEnabled()) {
      membercoverageResp.Response.EligibilityCoverage.map((data) => {
        data.MemberCoverage.map((coverageInfo) => {
          console.log('coverageInfo: ', coverageInfo);
          products[iIndex] = coverageInfo.CoverageType;
          console.log('products: ', coverageInfo.CoverageType);
          if (coverageInfo.BenefitPlan == null)
            //eslint-disable-next-line no-useless-concat
            MemberCoverageSummary.coverageInfo[iIndex] =
              data.MemberID + '#' + coverageInfo.CoverageType + '#' + 'NULL';
          else
            MemberCoverageSummary.coverageInfo[iIndex] =
              data.MemberID +
              '#' +
              coverageInfo.CoverageType +
              '#' +
              coverageInfo.BenefitPlan;

          console.log(
            'MemberCoverage.coverageInfo: ',
            MemberCoverageSummary.coverageInfo[iIndex],
          );
          iIndex++;
        });
      });

      console.log(
        'Corousel Selected Item: ',
        MemberCoverageSummary.getSelectedItem(),
      );
      console.log('Corousel Member Coverage: ', membercoverageResp);
      selectedItem = MemberCoverageSummary.getSelectedItem();

      if (selectedItem == 0 || selectedItem == 1) MemberSummary.memberSeqID = 0;
      else MemberSummary.memberSeqID = selectedItem - 1;

      memberAccumDetailsResp.Response.BenefitAccumulators.map((data) => {
        iIndex = 0;
        for (iIndex = 0; iIndex < products?.length; iIndex++) {
          if (products[iIndex] == data.Product) {
            if (
              MemberSummary.getNumberOfDependents() > 0 &&
              MemberSummary.memberSeqID == 0
            ) {
              InNetworkDed[iIndex] =
                data.Accumulators.PlanYearFamily.InNetworkDeductible;
              InNetworkOOP[iIndex] =
                data.Accumulators.PlanYearFamily.InNetworkOutOfPocket;
            } else {
              InNetworkDed[iIndex] =
                data.Accumulators.PlanYearPatient.InNetworkDeductible;
              InNetworkOOP[iIndex] =
                data.Accumulators.PlanYearPatient.InNetworkOutOfPocket;
            }
          }
        }
      });

      for (iIndex = 0; iIndex < products?.length; iIndex++) {
        DedFamilyAmt[iIndex] = 0;
        FamilyOOP[iIndex] = 0;
      }
      memberAccumDetailsResp.Response.PlanDetails.map((data) => {
        iIndex = 0;
        for (iIndex = 0; iIndex < products?.length; iIndex++) {
          if (
            products[iIndex] == data.Product &&
            data.BenefitScheduleType == 'In-Network'
          ) {
            if (
              MemberSummary.getNumberOfDependents() > 0 &&
              MemberSummary.memberSeqID == 0
            ) {
              if (data.Benefits == null) {
                DedFamilyAmt[iIndex] = 0;
                FamilyOOP[iIndex] = 0;
              } else {
                DedFamilyAmt[iIndex] = data.Benefits.DedFamilyAmount;
                FamilyOOP[iIndex] = data.Benefits.FamilyOutOfPocketAmount;
              }
            } else {
              if (data.Benefits == null) {
                DedFamilyAmt[iIndex] = 0;
                FamilyOOP[iIndex] = 0;
              } else {
                DedFamilyAmt[iIndex] = data.Benefits.DedIndividualAmount;
                FamilyOOP[iIndex] = data.Benefits.IndvOutOfPocketAmount;
              }
            }
          }
          //else
          //{
          //console.log('Setting to zero');
          //DedFamilyAmt[iIndex] = 0;
          //FamilyOOP[iIndex] = 0;
          //}
        }
      });

      for (iIndex = 0; iIndex < products?.length; iIndex++) {
        //For In Network
        //InNetworkDed[iIndex] = 0; // for no deductible testing purposes
        if (InNetworkDed[iIndex] == 0) {
          InNetworkRemaining = 0;
          InNetworkPercent = 0;
          MemberCoverageSummary.coverageInfo[iIndex] +=
            '#' + InNetworkRemaining + '#' + InNetworkPercent;
        } else {
          InNetworkRemaining = DedFamilyAmt[iIndex] - InNetworkDed[iIndex];
          if (isNaN(InNetworkRemaining)) InNetworkRemaining = 0;
          console.log('InNetworkRemaining: ', InNetworkRemaining);
          if (InNetworkRemaining <= 0) {
            InNetworkRemaining = 0;
            InNetworkPercent = 0;
          } else
            InNetworkPercent = Math.floor(
              (InNetworkDed[iIndex] / DedFamilyAmt[iIndex]) * 100,
            );

          if (isNaN(InNetworkPercent)) InNetworkPercent = 0;

          console.log('InNetworkPercent: ', InNetworkPercent);
          MemberCoverageSummary.coverageInfo[iIndex] +=
            '#' + InNetworkRemaining + '#' + InNetworkPercent;
        }

        console.log(
          'Calculated InNetwork: ',
          MemberCoverageSummary.coverageInfo[iIndex],
        );

        //For Out of Pocket
        console.log('FamilyOOP[iIndex]: ', FamilyOOP[iIndex]);
        console.log('InNetworkOOP[iIndex]: ', InNetworkOOP[iIndex]);

        if (InNetworkOOP[iIndex] == 0) {
          OOPRemaining = 0;
          OOPPercent = 0;

          MemberCoverageSummary.coverageInfo[iIndex] +=
            '#' + OOPRemaining + '#' + OOPPercent;
        } else if (InNetworkOOP[iIndex] == -1) {
          OOPRemaining = -1;
          OOPPercent = -1;

          MemberCoverageSummary.coverageInfo[iIndex] +=
            '#' + OOPRemaining + '#' + OOPPercent;
        } else {
          OOPRemaining = FamilyOOP[iIndex] - InNetworkOOP[iIndex];
          if (isNaN(OOPRemaining)) OOPRemaining = 0;

          console.log('OOPRemaining: ', OOPRemaining);
          if (OOPRemaining <= 0) {
            OOPRemaining = 0;
            OOPPercent = 0;
          } else
            OOPPercent = Math.floor(
              (InNetworkOOP[iIndex] / FamilyOOP[iIndex]) * 100,
            );

          if (isNaN(OOPPercent)) OOPPercent = 0;

          console.log('OOPPercent: ', OOPPercent);
          MemberCoverageSummary.coverageInfo[iIndex] +=
            '#' + OOPRemaining + '#' + OOPPercent;
        }

        console.log(
          'Calculated OOP: ',
          MemberCoverageSummary.coverageInfo[iIndex],
        );
      }
      MemberCoverageSummary.setReturnFlag(true);
    }

    const CustomSlider = ({ carouselState }) => {
      let value = 0;
      let carouselItemWidth = 400;

      if (this.Carousel) {
        carouselItemWidth = this.Carousel.state.itemWidth;
        const maxTranslateX = Math.round(
          //so that we don't over-slide
          carouselItemWidth *
            (this.Carousel.state.totalItems -
              this.Carousel.state.slidesToShow) +
            150,
        );
        value = maxTranslateX / 100; //calculate the unit of transform for the slider
      }
      const { transform } = carouselState;

      return (
        <div className="custom-slider">
          <input
            type="range"
            value={Math.round(Math.abs(transform) / value)}
            defaultValue={0}
            max={
              (carouselItemWidth *
                (carouselState.totalItems - carouselState.slidesToShow) +
                (this.state.additionalTransfrom === 150 ? 0 : 150)) /
              value
            }
            onChange={(e) => {
              if (this.Carousel.isAnimationAllowed) {
                this.Carousel.isAnimationAllowed = false;
              }
              const nextTransform = e.target.value * value;
              const nextSlide = Math.round(nextTransform / carouselItemWidth);
              if (
                e.target.value == 0 &&
                this.state.additionalTransfrom === 150
              ) {
                this.Carousel.isAnimationAllowed = true;
                this.setState({ additionalTransfrom: 0 });
              }
              this.Carousel.setState({
                transform: -nextTransform, //padding 20px and 5 items.
                currentSlide: nextSlide,
              });
            }}
            className="custom-slider__input"
          />
        </div>
      );
    };

    return (
      <div className="h-100">
        {/*Integration diabled */}
        {!this.state.disableIntegration && (
          <div>
            <div className="col-md-12 carousel-container">
              {membercoverageStaticResp.EligibilityCoverage.map((data) => {
                return (
                  <div key={data.MemberID}>
                    <Carousel
                      additionalTransfrom={0}
                      arrows
                      autoPlaySpeed={3000}
                      centerMode={false}
                      className=""
                      containerClass="container-with-dots"
                      dotListClass=""
                      draggable
                      focusOnSelect={false}
                      infinite={false}
                      keyBoardControl
                      minimumTouchDrag={80}
                      renderButtonGroupOutside={false}
                      showDots
                      renderDotsOutside={false}
                      itemClass="slider-image-item"
                      responsive={responsive}
                    >
                      {data.MemberCoverage.map((membercoverages) => {
                        return (
                          <div
                            className="carousel-li-item image-container increase-size"
                            key={data.MemberID}
                          >
                            <Col className="col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0">
                              <div className="slider-border">
                                {membercoverages.CoverageType === 'Vision' ? (
                                  <Row className="carousel-chart-coverage">
                                    <Col className="slider-last">
                                      <p>
                                        {t(
                                          'member.dashboard.coverage.coverage_para',
                                        )}
                                      </p>
                                      <h4>
                                        <a
                                          href="/member/dashboard-work-in-progress"
                                          className="find_coverage"
                                        >
                                          {t(
                                            'member.dashboard.coverage.coverage_para',
                                          )}
                                        </a>
                                      </h4>
                                    </Col>
                                  </Row>
                                ) : (
                                  <Row className="carousel-chart-coverage">
                                    <Col className="col-md-6 col-lg-6 col-sm-12 col-xs-12 carousel-chart-container">
                                      <DonutChart
                                        seriesRadial={[63]}
                                        chartType="radialBar"
                                        chartWidth="150"
                                      ></DonutChart>
                                      <p className="slide-name">
                                        {t(
                                          'member.dashboard.coverage.deductible_remaining',
                                        )}
                                      </p>
                                      <h4 className="slide-balance">$750.00</h4>
                                    </Col>
                                    <Col className="col-md-6 col-lg-6 col-sm-12 col-xs-12 carousel-chart-container">
                                      <DonutChart
                                        seriesRadial={[68]}
                                        chartType="radialBar"
                                        chartWidth="150"
                                      ></DonutChart>
                                      <p className="slide-name">
                                        {t(
                                          'member.dashboard.coverage.remaining',
                                        )}
                                      </p>
                                      <h4 className="slide-balance">
                                        $4,350.00
                                      </h4>
                                    </Col>
                                  </Row>
                                )}
                                {membercoverages.CoverageType === 'Vision' ? (
                                  <Row>
                                    <Col className="slider-details">
                                      <h3>{membercoverages.CoverageType} </h3>
                                      <p>&nbsp;</p>
                                      <p
                                        className="coverage-view-details"
                                        style={{ lineHeight: '18px' }}
                                      >
                                        &nbsp;
                                      </p>
                                    </Col>
                                  </Row>
                                ) : (
                                  <Row>
                                    <Col className="slider-details">
                                      <h3>{membercoverages.CoverageType} </h3>
                                      <p>
                                        {t('member.dashboard.coverage.plan')}{' '}
                                        <span>{data.BenefitPlan}</span>
                                      </p>
                                      <p className="coverage-view-details">
                                        <a href="/coverage">
                                          {t(
                                            'member.dashboard.coverage.view_coverage_details',
                                          )}
                                        </a>
                                      </p>
                                    </Col>
                                  </Row>
                                )}
                              </div>
                            </Col>
                          </div>
                        );
                      })}
                    </Carousel>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {/*Integration Enabled */}
        {this.state.disableIntegration && (
          <div>
            <div className="col-md-12 carousel-container">
              {membercoverageResp.Response.EligibilityCoverage.map((data) => {
                return (
                  <div key={data}>
                    <Carousel
                      additionalTransfrom={0}
                      arrows
                      autoPlaySpeed={3000}
                      centerMode={false}
                      className=""
                      containerClass="container-with-dots"
                      dotListClass=""
                      draggable
                      focusOnSelect={false}
                      infinite={false}
                      keyBoardControl
                      minimumTouchDrag={80}
                      renderButtonGroupOutside={false}
                      renderDotsOutside={false}
                      itemClass="slider-image-item"
                      responsive={responsive}
                    >
                      {
                        /*data.MemberCoverage.map((membercoverages) => {*/
                        MemberCoverageSummary.coverageInfo.map(
                          (coverageInfo) => {
                            MemberCoverageSummary.coverageListItem =
                              coverageInfo.split('#');
                            return (
                              <div
                                className="carousel-li-item image-container increase-size"
                                key={MemberCoverageSummary.coverageListItem[0]}
                              >
                                <Col className="col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0">
                                  <div className="slider-border">
                                    {' '}
                                    {MasterPermissions.CheckPermission(
                                      'View Deductible and Out of Pocket',
                                    ) &&
                                      (MemberCoverageSummary
                                        .coverageListItem[2] == 'NULL' ? (
                                        <Row className="carousel-chart-coverage">
                                          <Col className="slider-last">
                                            <p>
                                              You do not have{' '}
                                              {
                                                MemberCoverageSummary
                                                  .coverageListItem[1]
                                              }{' '}
                                              Coverage. Do you want to explore
                                              optoins?
                                            </p>
                                            <h4>
                                              {t(
                                                'member.dashboard.coverage.find_coverage_options',
                                              )}
                                            </h4>
                                          </Col>
                                        </Row>
                                      ) : (
                                        <div className="carousel-chart-coverage">
                                          <Row>
                                            {MemberCoverageSummary
                                              .coverageListItem[4] === '0' ? (
                                              <Col className="col-md-6 col-lg-6 col-sm-6 col-xs-12 text-center my-auto">
                                                <p id="no-deductible-small">
                                                  {t(
                                                    'member.dashboard.coverage.this_plan',
                                                  )}
                                                </p>
                                                <p id="no-deductible">
                                                  {t(
                                                    'member.dashboard.coverage.no_deductible',
                                                  )}
                                                </p>
                                              </Col>
                                            ) : (
                                              <Col className="col-md-6 col-lg-6 col-sm-6 col-xs-12 carousel-chart-container">
                                                <DonutChart
                                                  seriesRadial={[
                                                    MemberCoverageSummary
                                                      .coverageListItem[4],
                                                  ]}
                                                  chartType="radialBar"
                                                  chartWidth="130"
                                                ></DonutChart>
                                                <p className="slide-name">
                                                  {t(
                                                    'member.dashboard.coverage.deductible_remaining',
                                                  )}
                                                </p>
                                                <h4 className="slide-balance">
                                                  {formatter.format(
                                                    MemberCoverageSummary
                                                      .coverageListItem[3],
                                                  )}
                                                </h4>
                                              </Col>
                                            )}
                                            {MemberCoverageSummary
                                              .coverageListItem[5] === '-1' ? (
                                              <Col className="col-md-6 col-lg-6 col-sm-6 col-xs-12 text-center my-auto">
                                                <p id="unlimited-oop-small">
                                                  {t(
                                                    'member.dashboard.coverage.this_plan',
                                                  )}
                                                </p>
                                                <p id="unlimited-oop-middle">
                                                  {t(
                                                    'member.dashboard.coverage.unlimited',
                                                  )}
                                                </p>
                                                <p id="unlimited-oop-bottom">
                                                  {t(
                                                    'member.dashboard.coverage.out_of_pocket',
                                                  )}
                                                </p>
                                              </Col>
                                            ) : (
                                              <Col className="col-md-6 col-lg-6 col-sm-6 col-xs-12 carousel-chart-container">
                                                <DonutChart
                                                  seriesRadial={[
                                                    MemberCoverageSummary
                                                      .coverageListItem[6],
                                                  ]}
                                                  chartType="radialBar"
                                                  chartWidth="130"
                                                ></DonutChart>
                                                <p className="slide-name">
                                                  {t(
                                                    'member.dashboard.coverage.remaining',
                                                  )}
                                                </p>
                                                <h4 className="slide-balance">
                                                  {formatter.format(
                                                    MemberCoverageSummary
                                                      .coverageListItem[5],
                                                  )}
                                                </h4>
                                              </Col>
                                            )}
                                          </Row>
                                        </div>
                                      ))}
                                    {MemberCoverageSummary
                                      .coverageListItem[2] != 'NULL' ? (
                                      <Row>
                                        <Col className="slider-details">
                                          <h3>
                                            {
                                              MemberCoverageSummary
                                                .coverageListItem[1]
                                            }{' '}
                                          </h3>
                                          <p>
                                            {t(
                                              'member.dashboard.coverage.plan',
                                            )}{' '}
                                            <span>
                                              {
                                                MemberCoverageSummary
                                                  .coverageListItem[2]
                                              }
                                            </span>
                                          </p>
                                          {MasterPermissions.CheckPermission(
                                            'View Coverage Details',
                                          ) && (
                                            <p className="coverage-view-details">
                                              <Link
                                                to={
                                                  coverageDetailsRoute +
                                                  MemberCoverageSummary
                                                    .coverageListItem[1]
                                                }
                                              >
                                                {t(
                                                  'member.dashboard.coverage.view_coverage_details',
                                                )}
                                              </Link>
                                            </p>
                                          )}
                                        </Col>
                                      </Row>
                                    ) : (
                                      <Row>
                                        <Col className="slider-details">
                                          <h3>
                                            {
                                              MemberCoverageSummary
                                                .coverageListItem[1]
                                            }{' '}
                                          </h3>
                                          <p>
                                            You do not have{' '}
                                            {
                                              MemberCoverageSummary
                                                .coverageListItem[1]
                                            }{' '}
                                            Coverage.
                                          </p>
                                          <p className="coverage-view-details">
                                            <Link to={'#'}>
                                              {t(
                                                'member.dashboard.coverage.find_coverage_options',
                                              )}
                                            </Link>
                                          </p>
                                        </Col>
                                      </Row>
                                    )}
                                  </div>
                                </Col>
                              </div>
                            );
                          },
                        )
                      }
                    </Carousel>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(CarouselSlider);
